import type { MessageKey } from '../i18n/messages';

export function assistantVoiceErrorCopy(code: string): {
  key: MessageKey;
  params?: Record<string, string>;
} {
  if (code === 'not-allowed' || code === 'service-not-allowed' || code === 'mic-unavailable') {
    return { key: 'assistant.voice.denied' };
  }
  if (code === 'no-speech' || code === 'cloud-stt-empty') {
    return { key: 'assistant.voice.empty' };
  }
  if (code === 'unavailable' || code === 'start-failed') {
    return { key: 'assistant.voice.unsupported' };
  }
  return { key: 'assistant.voice.error', params: { code } };
}
